// extracted by mini-css-extract-plugin
export default {"text":"CheckChangePasswordLink_text--O2S","supportLink":"CheckChangePasswordLink_supportLink--w4f","icon":"CheckChangePasswordLink_icon--BQ0"};